module.exports = __webpack_public_path__ + "static/media/Ally_web_3.2adc9e3a.jpg";